import type { IconData } from '@stacksjs/iconify-core'

export const yinYangSymbolFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 46.5C11.574 46.5 1.5 36.426 1.5 24S11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M46.5 24C46.5 11.574 36.426 1.5 24 1.5c6.213 0 11.25 5.037 11.25 11.25S30.213 24 24 24s-11.25 5.037-11.25 11.25S17.787 46.5 24 46.5c12.426 0 22.5-10.074 22.5-22.5m-27 10.5a4.5 4.5 0 1 1 9 0a4.5 4.5 0 0 1-9 0\" clip-rule=\"evenodd\"/><path fill=\"#2859c5\" d=\"M24 9a4.5 4.5 0 1 0 0 9a4.5 4.5 0 0 0 0-9\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default yinYangSymbolFlat
